import { render } from "./SlidingBanner.vue?vue&type=template&id=31f9091e"
import script from "./SlidingBanner.vue?vue&type=script&lang=js"
export * from "./SlidingBanner.vue?vue&type=script&lang=js"

import "./SlidingBanner.vue?vue&type=style&index=0&id=31f9091e&lang=less&scope=true"

import exportComponent from "F:\\work\\projects\\HiOmics\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__